import { render, staticRenderFns } from "./DietitianAppointments.vue?vue&type=template&id=c856a1a8&scoped=true&"
import script from "./DietitianAppointments.vue?vue&type=script&lang=js&"
export * from "./DietitianAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c856a1a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
